<div class="container mt-5 pb-5">
    <div class="row justify-content-center">
        <div class="col-lg-7 col-md-8 col-sm-11 col-10" *ngIf="dataRenovation">
            <h2 class="text-center mt-3 mb-5">RENOVACIÓN CONTRATO Nº {{dataRenovation.numeroContrato}}</h2>
            <div class="border-table">
                <div class="row">
                    <div class="col-md-6">
                        Número de contrato
                    </div>
                    <div class="col-md-6 font-weight-bold text-right">
                        {{dataRenovation.numeroContrato}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        Fecha de vencimiento
                    </div>
                    <div class="col-md-6 font-weight-bold text-right">
                        {{dataRenovation.fechaVencimiento | date: "dd/MM/yyyy"}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        Precio de la renovación
                    </div>
                    <div class="col-md-6 font-weight-bold text-right">
                        {{dataRenovation.precioRecompraRenovacion | number :'1.2-2'}} €
                    </div>
                </div>
                <div class="row" *ngIf="dataRenovation.importePenalizaciones > 0">
                    <div class="col-md-6">
                        Importe de penalización
                    </div>
                    <div class="col-md-6 font-weight-bold text-right">
                        {{dataRenovation.importePenalizaciones | number :'1.2-2'}} €
                    </div>
                </div>
                <div class="row" *ngIf="dataRenovation.importePenalizaciones > 0">
                    <div class="col-md-6">
                        Total a pagar
                    </div>
                    <div class="col-md-6 font-weight-bold text-right">
                        {{dataRenovation.precioRecompraRenovacion + dataRenovation.importePenalizaciones| number :'1.2-2'}} €
                    </div>
                </div>

            </div>
            <div class="border-table legal-text" id="legal-text" (scroll)="divScroll('legal-text')">
                <app-contract-policy></app-contract-policy>
            </div>
            <div class="error-warning error-conditions" *ngIf="(form.invalid && form.dirty) || form.touched">
                <div *ngIf="!legalScrollOK">
                    Debe leer las condiciones legales hasta el final
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-11 col-10">
            <form class="form-policies" [formGroup]="contractSummaryCheck" (ngSubmit)="onSubmit()">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" formControlName="acceptConditions" id="accept-conditions">
                    <label class="custom-control-label" for="accept-conditions"> Haciendo click en el presente apartado, el Cliente confirma que ha leído y acepta las condiciones establecidas en el documento de renovación del Contrato disponible en su área de cliente</label>
                </div>
                <div class="error-warning" *ngIf="(form.invalid && form.dirty) || form.touched">
                    <!-- Required -->
                    <div *ngIf="form.errors?.required">
                        Es requerido
                    </div>
                </div>
                <button id="submit-renew-button" type="submit" class="form-button btn btn-primary">
                    Renovar
                </button>
            </form>
        </div>
    </div>
</div>
<app-modal [attr.id]="modalId" [modalId]="modalId" class="d-none" closeAction="navigateToHome">
    <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-12 offset-0 text-center message-container my-5">
        <p>{{textMessage}}</p>
    </div>
</app-modal>
<app-loader *ngIf="showLoader"></app-loader>
